import React, { useState } from "react";

interface Props {
  title: string;
  body: React.ReactNode;
}

const AccordionItem = ({ title, body }: Props) => {
  const [active, setActive] = useState<boolean>(false);

  return (
    <article className="border-b">
      <div
        className={`border-l-2 bg-grey-100 ${
          active ? "border-yellow-500" : "border-transparent"
        }`}
      >
        <header
          className="flex justify-between items-center p-5 pl-8 pr-8 cursor-pointer select-none"
          onClick={() => setActive(!active)}
        >
          <span
            className={`${
              active ? "text-yellow-500" : "text-gray-800"
            } font-thin text-xl`}
          >
            {title}
          </span>
          <div
            className={`rounded-full border w-7 h-7 flex items-center justify-center ${
              active ? "border-yellow-500 bg-yellow-500" : ""
            }`}
          >
            <svg
              aria-hidden="true"
              fill="none"
              height="24"
              stroke={`${active ? "white" : "#2d3748"}`}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {active ? (
                <polyline points="18 15 12 9 6 15" />
              ) : (
                <polyline points="6 9 12 15 18 9" />
              )}
            </svg>
          </div>
        </header>
        {active && (
          <div>
            <div className="px-10 pb-5 text-gray-800">{body}</div>
          </div>
        )}
      </div>
    </article>
  );
};

export default AccordionItem;
